const outlineLocalization = {
  label: 'On this page',
}

export default outlineLocalization
